<template>
  <div class="card">
    <div class="background" :style="{'background-image': 'url('+ sanitizeUrl(background) +')'}">
    </div>
    <div class="content">
      <div class="action-button">
        <button role="button" tabindex="0" style="text-transform: uppercase">{{ $t('lbl_explore') }}</button>
      </div>
    </div>
    <h4>{{title}}</h4>
  </div>
</template>

<script>
  export default {
    name: "ExCard",
    props: ["title", "background"],
    methods: {
      sanitizeUrl(url) {
        return url !== undefined && url !== null && url.replace(/ /g, "%20");
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~css_vars";
  @import "~mixins";

  .card {
    border-radius: 0;
    border: none;
    min-height: 330px;
    min-width: 23.5%;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: none;
    flex: 1;

    &:not(:last-child) {
      margin:0 20px 0 0;
    }

    &:last-child {
      margin-bottom: 0;
    }

    h4 {
      text-transform: uppercase;
      font-family: "Gilda Display";
      font-size: 1.2rem;
      z-index: 1;
      font-weight: 400;
      position: absolute;
      bottom: -15px;
      &.bold-theme {
        font-family: 'Roboto';
      }
    }

    .background {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 85%;
      background-position: center center;
      background-size: cover;
      transition: transform 0.4s ease;
    }
    .content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 85%;
      z-index: 3;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 10px;
      .action-button{
        opacity: 0;
        text-transform: uppercase;
        color: white;
        font-weight: 300;
        font-family: "Gilda Display";
        font-size: 2rem;
        margin: 0 0 10px 0;
      }
      button {
        background-color: transparent;
        border-radius: 100%;
        color: white;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 300;
        height: 80px;
        width: 80px;
        padding: 0px;
        min-width: unset;
        z-index: 10;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          width: 80px;
          height: 80px;
          border: solid 1px rgba(white, 0.8);
          border-radius: 100%;
          z-index: -1;
        }
        &:hover {
          color: $black;
          &::after {
            background-color: white;
          }
        }
      }
      .action-button {
        transform: translateY(100px);
        width: auto;
      }
      h4 {
        transform: translateY(40px);
      }
    }
    &:hover,
    &:focus {
      .background {
        transition: all 0.4s ease-out 0.1s;
        transform: scale(1);
      }
      .content {
        background-color: rgba(black, 0.4);
      }
      .content .action-button,
      .content h4 {
        transition: all 0.4s ease-out 0.1s;
        opacity: 1;
      }
      .content .action-button {
        transform: translateY(0px);
      }
      .content h4 {
        transform: translateY(0px);
      }
    }
  }

  @include media("<=tablet") {
    .card {
      min-width: 31%;
      flex: initial;
      margin: 0 !important;
    }
  }

  @include media("<=phone") {
    .card {
      margin: 0 0 20px 0 !important;
      min-width: 100%;
    }
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    /* IE10+ CSS styles go here */

    button {
      min-width: 50px;
    }
  }
</style>
